const layout = () => import('../../gerente/layout.vue')
const gerenteCadastroLote = () => import('./gerenteCadastroLote.vue')

const gerenteCadastroLoteRoutes = {
  component: layout,
  children: [
    {
      path: '',
      name: 'gerenteCadastroLote',
      component: gerenteCadastroLote,
    },
  ],
}

export default gerenteCadastroLoteRoutes
